<template>
  <template v-if="isModal">
    <div
      class="mb-1 card-toolbar"
      v-if="panelFun.length > 0 || !!$slots['panel-info']"
    >
      <PanelFun :items="panelFun" v-if="panelFun.length > 0"></PanelFun>
      <div class="card-toolbar-info" v-if="$slots['panel-info']">
        <slot name="panel-info"></slot>
      </div>
    </div>
    <slot></slot>
  </template>
  <template v-else>
    <div :class="{ card: true, 'fixed-top h-100 rounded-0': fullScreen }">
      <div
        :class="[
          'card-header header-elements-inline bg-white',
          { 'sticky-header': panelFun.length > 0 },
        ]"
      >
        <div class="card-title card-toolbar">
          <PanelFun :items="panelFun" v-if="panelFun.length > 0"></PanelFun>
          <div class="card-toolbar-info" v-if="$slots['panel-info']">
            <slot name="panel-info"></slot>
          </div>
        </div>

        <div class="header-elements">
          <div class="list-icons">
            <a
              href="#"
              class="list-icons-item"
              @click="onCollapse"
              v-if="collapsed"
            >
              <i
                :class="collapse ? 'icon-arrow-down12' : 'icon-arrow-up12'"
              ></i>
            </a>
            <a
              href="#"
              class="list-icons-item"
              @click="onScreenFull"
              :title="fullScreen ? 'Свернуть' : 'Развернуть на весь экран'"
            >
              <i
                :class="
                  fullScreen ? 'icon icon-minimize' : 'icon icon-maximize'
                "
              ></i>
            </a>
          </div>
        </div>
      </div>
      <div class="card-body" :style="{ display: collapse ? 'none' : 'block' }">
        <slot></slot>
      </div>
      <div class="card-footer" v-if="panelFunFooter.length > 0">
        <PanelFun :items="panelFunFooter"></PanelFun>
      </div>
    </div>
  </template>
</template>

<script>
import { computed, defineComponent, ref } from "vue";
import PanelFun from "@/components/PanelFun.vue";
import { panels, thisPanelModal } from "@/layouts/layouts";

export default defineComponent({
  components: {
    PanelFun,
  },

  props: {
    panelFun: {
      type: Array,
      default: () => [],
    },
    panelFunFooter: {
      type: Array,
      default: () => [],
    },
    panel: {
      type: String,
      default: null,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const fullScreen = ref(false);
    const collapse = ref(false);

    const onScreenFull = () => {
      fullScreen.value = !fullScreen.value;
    };

    const onCollapse = () => {
      collapse.value = !collapse.value;
    };

    const isModal = computed(() =>
      panels.value.some((el) => el.key == props.panel && el.modal),
    );

    return {
      fullScreen,
      collapse,
      onScreenFull,
      onCollapse,
      thisPanelModal,
      isModal,
    };
  },
});
</script>

<style>
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fafafa !important;
  border-bottom: 1px solid #ddd !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.11) !important;
}
.card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.card-toolbar-info {
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .card-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
